import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Tabs, Tab, Tooltip} from '@material-ui/core';
import {useSelector} from 'react-redux';
import authenticationService from '../../../services/authentication/AuthenticationService';

function TabsView(props) {
  const isManager = authenticationService.roles().isManager();
  const isDepositor = useSelector(state => state.organisation.depositor);

  // Used to avoid bad props warning on Tooltip
  function CloneProps(tabProps) {
    const {children, ...other} = tabProps;
    return children(other);
  }

  function getSubscriptionTab() {
    const tab = tabProps => (
      <Tab
        {...tabProps}
        data-id="tab-organisation-subscription-and-invoices"
        value="/subscription"
        label={<div className="m-0"><Translate value="organisationSetting.subscriptionAndInvoicesTitle"/></div>}
        disabled={!isManager}
      />
    );

    return isManager ?
      tab() :
      <CloneProps>
        {tabProps => (
          <Tooltip title={<Translate value="organisationSetting.subscriptionAndInvoicesTabDisabled"/>}>
            <div>{tab(tabProps)}</div>
          </Tooltip>
        )}
      </CloneProps>;
  }

  function getMandatesTab(isCollectionMandate) {
    const tooltipLabelKey = !isDepositor ? 'notDepositor' : 'notManager';
    const translationPath = `organisationSetting.mandates.${isCollectionMandate ? 'collection' : 'broadcast'}`;
    const tab = tabProps => (
      <Tab
        {...tabProps}
        data-id={`tab-organisation-${isCollectionMandate ? 'collection' : 'broadcast'}-mandates`}
        value={isCollectionMandate ? '/collection-mandates' : '/broadcast-mandates'}
        label={<div className="m-0"><Translate value={`${translationPath}.title`}/></div>}
        disabled={!isManager || !isDepositor}
      />
    );

    return isDepositor && isManager ?
      tab() :
      <CloneProps>
        {tabProps => (
          <Tooltip title={<Translate value={`${translationPath}.${tooltipLabelKey}`}/>}>
            <div>{tab(tabProps)}</div>
          </Tooltip>
        )}
      </CloneProps>;
  }

  return (
    <div style={{backgroundColor: '#f5f5f5', margin: '0 -45px 30px', padding: '0 45px'}}>
      <Tabs
        value={props.currentNav}
        onChange={props.onTabSelect}
        textColor="primary"
        TabIndicatorProps={{style: {backgroundColor: '#E72580'}}}
      >
        <Tab
          data-id="tab-organisation-details"
          value="/details"
          label={<div className="m-0"><Translate value="organisationSetting.detailsTitle"/></div>}
        />
        <Tab
          data-id="tab-organisation-users"
          value="/users"
          label={<div className="m-0"><Translate value="organisationSetting.usersTitle"/></div>}
        />
        {getSubscriptionTab()}
        {getMandatesTab(true)}
        {getMandatesTab(false)}
      </Tabs>
    </div>
  );
}

TabsView.propTypes = {
  currentNav: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  onTabSelect: PropTypes.func.isRequired
};

export default TabsView;
